import { render, staticRenderFns } from "./SelectButacasBloqueadosComponent.vue?vue&type=template&id=3bf155a4"
import script from "./SelectButacasBloqueadosComponent.vue?vue&type=script&lang=js"
export * from "./SelectButacasBloqueadosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports